export interface TimePlanner_Interval {
  total_planned: number;
  staff_only_planned: number;
  minute: number;
}

export interface TimePlanner_Hour {
  hourNumber: number;
  total_planned: number;
  staff_only_planned: number;
  intervals: TimePlanner_Interval[];
}

export interface TimePlanner_Day {
  dayNumber: number;
  total_planned: number;
  staff_only_planned: number;
  selected_date?: Date;
  hours: TimePlanner_Hour[];
}

export interface TimePlannerState {
  openHourInSeconds: number;
  closeHourInSeconds: number;
  timeInterval: number;
  day: TimePlanner_Day;
}

export enum TimePlannerActionType {
  SET_DEFAULT_STATE,
  SET_DAY_LIMIT,
  SET_HOUR_LIMIT,
  SET_INTERVAL_LIMIT,
  SET_ONLINE_ACTION,
}

export interface SET_DEFAULT_STATE {
  type: TimePlannerActionType.SET_DEFAULT_STATE;
  payload: TimePlannerState;
}

export interface SET_ONLINE_ACTION {
  type: TimePlannerActionType.SET_ONLINE_ACTION;
  payload?: {
    state?: TimePlannerState;
  };
}

export interface SET_DAY_LIMIT {
  type: TimePlannerActionType.SET_DAY_LIMIT;
  payload: {
    value: number;
    staffOnly?: boolean;
  };
}

export interface SET_HOUR_LIMIT {
  type: TimePlannerActionType.SET_HOUR_LIMIT;
  payload: {
    hourIndex: number;
    value: number;
    staffOnly?: boolean;
  };
}

export interface SET_INTERVAL_LIMIT {
  type: TimePlannerActionType.SET_INTERVAL_LIMIT;
  payload: {
    hourIndex: number;
    intervalIndex: number;
    value: number;
    staffOnly?: boolean;
  };
}

export type TimePlannerActions =
  | SET_ONLINE_ACTION
  | SET_DEFAULT_STATE
  | SET_DAY_LIMIT
  | SET_HOUR_LIMIT
  | SET_INTERVAL_LIMIT;
